import { PtXy, MetricsRouteData } from '../../appTypes';
import {
  ChartDataExpander,
  parse_ts,
  sparseToDense,
} from './ChartDataExpander';

export type TravelTimeArray = (PtXy & { quality: number })[];

export class TravelTimeChartDataExpander extends ChartDataExpander {
  expandTravelTimes(metrics: MetricsRouteData): TravelTimeArray {
    // extract and backfill sparse TT Data array with null datapoints for all time bins
    // Infer bin size from first row bin size
    if (metrics) {
      console.assert(metrics.bin_size !== undefined, metrics);
      this.binTicksMs = metrics.bin_size * 60 * 1000;
    } else {
      return undefined;
    }
    if (metrics?.times) {
      const dense = sparseToDense(
        metrics.times,
        this.firstBin,
        this.lastBin,
        this.binTicksMs,
        this.offsetTo,
        (row) => {
          return {
            x: parse_ts(row[0]),
            y: row[1],
            quality: row[2],
          };
        },
      );

      return dense as TravelTimeArray;
    }
    return undefined;
  }

  expandQuestionableTraveltimes(metrics: MetricsRouteData) {
    const dense = this.expandTravelTimes(metrics);

    const questionableIndexes = [];
    const goodIndexes = [];
    const goodNullMiddle = [];
    const questionableNullMiddle = [];
    // Each pair i, i+1 of dense points belongs to either the questionable or good series
    // NB this will result in duplicate indexes but we solve this trivially with the .includes, same with indexes out of range
    // We also indicate that we want to introduce a breaking null datapoint in the middle so a questionable-good-questionable set of points
    // Doesn't result in a solid questionable run, and visa versa
    for (let i = 0; i < dense.length; i++) {
      if ((dense[i] as any).quality !== 0) {
        questionableIndexes.push(i, i + 1);
        if (goodIndexes.includes(i)) {
          goodNullMiddle.push(i);
        }
      } else {
        goodIndexes.push(i, i + 1);
        if (questionableIndexes.includes(i)) {
          questionableNullMiddle.push(i);
        }
      }
    }

    const questionableDense = [];
    const goodDense = [];
    for (let i = 0; i < dense.length; i++) {
      if (goodIndexes.includes(i)) {
        goodDense.push(dense[i]);
      } else {
        goodDense.push({ ...dense[i], y: null });
      }
      if (questionableIndexes.includes(i)) {
        questionableDense.push(dense[i]);
      } else {
        questionableDense.push({ ...dense[i], y: null });
      }

      if (i < dense.length - 1) {
        if (goodNullMiddle.includes(i)) {
          goodDense.push({
            ...dense[i],
            x: (dense[i].x + dense[i + 1].x) / 2,
            y: null,
          });
        }

        if (questionableNullMiddle.includes(i)) {
          questionableDense.push({
            ...dense[i],
            x: (dense[i].x + dense[i + 1].x) / 2,
            y: null,
          });
        }
      }
    }

    return { goodDense, questionableDense, rawDense: dense };
  }
}
